// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_DestroyResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for destroy() DELETE /fechamentos/{id}
 * Returns confirmation of successful deletion
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_DestroyResponseDados {
id?: number
deleted?: boolean
}

export type Fechamentos_DestroyResponse = ApiResponse<Fechamentos_DestroyResponseDados>;

registerResponseContract('Fechamentos_DestroyResponse', {
  id:      { type: 'number',  required: false },
  deleted: { type: 'boolean', required: false },
})
